import { store } from '@betacrew/jars-flux'
import { W8_W9_PAYMENT_MODAL_LOADING_STATES } from './constants';

export const componentKey = "PAYMENT_MODAL/W8W9";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSelectedW8W9Plan: (state, action) => {
            state.selectedW8W9Plan = action.payload
        },
        setW8W9PaymentDrawerModal: (state, action) => {
            state.w8W9PaymentDrawerModal = action.payload
        },
        setW8W9FormsModal: (state, action) => {
            state.w8W9FormsModal = action.payload
        },
        setSelectedW8W9Form: (state, action) => {
            state.selectedW8W9Form = action.payload
        },
        setW8Forms: (state, action) => {
            state.w8Forms = action.payload
        },
        setW9RequestModal: (state, action) => {
            state.w9RequestModal = action.payload
        },
        setW8W9Fees: (state, action) => {
            state.W8W9Fees = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setHasEnoughRequests: (state, action) => {
            state.hasEnoughRequests = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: W8_W9_PAYMENT_MODAL_LOADING_STATES.GET_W8_FORMS_LOADING },
        selectedW8W9Plan: { value: "", label: "" },
        selectedW8W9Form: { value: "", label: "" },
        w8Forms: [],
        W8W9Fees: 0,
        hasEnoughRequests: false,

        //modals
        w8W9FormsModal: false,
        w8W9PaymentDrawerModal: false,
        w9RequestModal: false
    }
});

export const { setSelectedW8W9Plan, setW8W9PaymentDrawerModal, setW8W9FormsModal, setSelectedW8W9Form, setW8Forms, setW9RequestModal, setW8W9Fees, setLoadingState, setHasEnoughRequests } = actions;
